import { INTEGRATION_CODE } from "../../../../../models/IntegrationsTypes";
import { makeAutoObservable } from "mobx";
import { ICredentialsStore } from "../integration-store";
import IntegratorOAuthHandler from "./oauth-handler/integrator-oauth-handler";

export interface IZendeskOAuthCredentials {
    subdomain: string,
    brandId?: string,
}

class ZendeskOAuthCredentialsStore implements ICredentialsStore {
    private _changes: IZendeskOAuthCredentials = {} as IZendeskOAuthCredentials;
    private _oauthHandler = new IntegratorOAuthHandler(INTEGRATION_CODE.ZENDESK_OAUTH);
    
    constructor() {
        makeAutoObservable(this);
    }

    public get subdomain() { return this._changes.subdomain; }
    public set subdomain(v: string) { this._changes.subdomain = v; }

    public get brandId() { return this._changes.brandId || ''; }
    public set brandId(v: string) { this._changes.brandId = v; }

    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IZendeskOAuthCredentials;
    }

    async getCredentials() {
        const credentials = await this._oauthHandler.getCredentials(this._changes);
        // @ts-ignore
        delete credentials.oauthPayload.success
        return credentials;
    }


}

export default ZendeskOAuthCredentialsStore;
